import { faSearch, faTimes } from "@/icons/solid-icons";
import Icon from "../Icon";
import Input from "../Inputs/Input";
import type { ISearchBarFilter } from "@/types/library/Filters";
import { cn } from "@/utils/css";

const SearchBar = ({ vm }: { vm: ISearchBarFilter }) => {
  return (
    <div
      className={cn("relative mt-2 mb-4", vm.labels.containerClassName)}
      id={vm.labels.id}
      data-testid={vm.labels.id}
    >
      <Input
        value={vm.value}
        id={`${vm.labels.id}-input`}
        placeholder={vm.labels.placeholder}
        inputClassName={cn("pr-8 pl-10 shadow-lg", vm.labels.width)}
        inputBackground={vm.labels.backgroundColour}
        onChange={vm.onHandleSearch}
        customRef={vm.customRef}
      />
      <Icon
        icon={faSearch}
        className="absolute top-[15px] left-[12px] text-gray-400"
      />
      <Icon
        id={`${vm.labels.id}-clear`}
        data-testid={`${vm.labels.id}-clear`}
        icon={faTimes}
        className="absolute top-[15px] right-[12px] cursor-pointer text-gray-400 hover:text-dines-purple-darkest"
        onClick={vm.onClearSearch}
      />
    </div>
  );
};

export default SearchBar;
